export default "__VITE_ASSET__iqoZj64j__"